module.exports = __webpack_public_path__ + "assets/img/Dining Cabana.d8bc3b28.jpg";